import { render, staticRenderFns } from "./DataHistoryInspectorPage.vue?vue&type=template&id=0fa3d232"
import script from "./DataHistoryInspectorPage.vue?vue&type=script&lang=js"
export * from "./DataHistoryInspectorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports